import { Page } from "../../shared/utils/http-utils";
import { jwtAuthAxios } from "../../shared/utils/network-utils";
import { City, CreateOrUpdateCity } from "../../survey/models/City";

export const AdminCityApi = {
  page: async (pageSize: number, pageNumber: number) =>
    await jwtAuthAxios().get<Page<City>>(`/admin/cities`, {
      params: { "page[size]": pageSize, "page[number]": pageNumber },
    }),

  update: async (cityId: string, body: CreateOrUpdateCity) => {
    return await jwtAuthAxios().put<City>(`/admin/cities/${cityId}`, body);
  },

  deleteOsmData: async (cityId: string) => {
    return await jwtAuthAxios().delete<null>(
      `/admin/cities/${cityId}/osm-data`,
    );
  },

  delete: async (cityId: string) => {
    return await jwtAuthAxios().delete<null>(`/admin/cities/${cityId}`);
  },
};
